import {useEffect, useState} from "react";
import {findLocationsWithPagination} from "../api/eventGroupApiClient";

export const useLocations = (page, pageSize, reloadTrigger) => {
    const [locations, setLocations] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const locationsWithPagination = findLocationsWithPagination(page, pageSize, abortController.signal);

        locationsWithPagination
            .then(
                (data) => {
                    const locations = data.locations;
                    const pagination = data.pagination;

                    setLocations(locations)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {locations : locations, pagination};
}